class CircleMaskReveal extends Phaser.Group {
  constructor({ game }) {
    super(game);
    this.background = this.game.make.image(0, 0, 'bg_generic');
    this.add(this.background);

    this.maskp = this.game.add.graphics();
    this.maskp.beginFill(0x000000, 1);
    this.maskp.drawCircle(0, 0, 10);
    this.maskp.endFill();
    this.maskp.anchor.set(0.5);
    this.maskp.position.set(this.game.width * 0.5, this.game.height * 0.5);
    this.addChild(this.maskp);
    this.background.mask = this.maskp;
    this.maskp.diameter = 1;

    this.onInComplete = new Phaser.Signal();
    this.onOutComplete = new Phaser.Signal();
  }

  init() {}

  startIn() {
    let track = { step: 0 };
    let tween = this.game.add.tween(track).to({ step: 1280 }, 1250, Phaser.Easing.Circular.Out);
    tween.onUpdateCallback(() => {
      this.maskp.beginFill(0x000000, 0);
      this.maskp.drawCircle(0, 0, track.step);
      this.maskp.endFill();
    });
    tween.start();
    tween.onComplete.addOnce(this.startInComplete, this);
    //
    // this.tween = this.game.add
    //   .tween(this.maskp)
    //   .to({ diameter: 1280 }, 1250, Phaser.Easing.Circular.Out, true);
    // this.tween.onComplete.addOnce(this.startInComplete, this);
  }

  startInComplete() {
    this.onInComplete.dispatch(this);
  }

  startOut() {
    let track = { step: 0 };
    let tween = this.game.add.tween(track).to({ step: 1280 }, 1250, Phaser.Easing.Circular.In);
    tween.onUpdateCallback(() => {
      this.maskp.clear();
      this.maskp.beginFill(0x000000, 0);
      this.maskp.drawCircle(0, 0, 1280 - track.step);
      this.maskp.endFill();
    });
    tween.start();
    tween.onComplete.addOnce(this.startOutComplete, this);
    // this.tween = this.game.add
    //   .tween(this.maskp)
    //   .to({ diameter: 1 }, 1250, Phaser.Easing.Circular.In, true);
    // this.tween.onComplete.addOnce(this.startOutComplete, this);
  }

  startOutComplete() {
    this.onOutComplete.dispatch(this);
  }

  destroy(destroyChildren = true, soft) {
    this.onInComplete.forget();
    this.onInComplete.dispose();
    this.onInComplete.removeAll();

    this.onOutComplete.forget();
    this.onOutComplete.dispose();
    this.onOutComplete.removeAll();

    this.background = null;
    this.maskp = null;
    super.destroy(destroyChildren);
  }
}
export default CircleMaskReveal;
